/* ============================================================
   custom.js - eigen aanpassingen Margaret & Birdie
   Geladen via snippets/stylesheets.liquid.

   Maakt van de vaste 'Add to cart'-balk onderin een compacte balk
   (zoals Caldenne): fotootje, titel, gekozen kleur/maat, prijs en
   de knop. En laat hem pas verschijnen als de bezoeker voorbij de
   koopknop is gescrold.
   ============================================================ */
(function () {
  'use strict';

  var bar = document.querySelector('[data-sticky-bar]');
  if (!bar) return;

  var price = bar.querySelector('[data-sticky-price]');
  if (!price || !bar.querySelector('.product-sticky-bar__content')) return;

  var section = bar.closest('[data-product-section]');

  /* De balk zit in de infokolom, die op desktop 'sticky' is met z-index 25.
     Daardoor schoven secties verderop over de balk heen en leek hij
     soms doorzichtig. Naar <body> verplaatsen haalt hem daar uit. */
  document.body.appendChild(bar);
  var product = null;
  try {
    var json = section && section.querySelector('[data-product-json]');
    product = json ? JSON.parse(json.textContent) : null;
  } catch (e) {
    product = null;
  }

  /* ---------- opbouw ---------- */
  var left = price.parentElement;
  left.classList.add('sb-left');

  var thumb = document.createElement('img');
  thumb.className = 'sb-thumb';
  thumb.alt = '';
  thumb.width = 52;
  thumb.height = 52;
  left.parentElement.insertBefore(thumb, left);

  var title = left.querySelector('.product-sticky-bar__title');

  var variantLine = document.createElement('p');
  variantLine.className = 'sb-variant';
  if (title && title.nextSibling) left.insertBefore(variantLine, title.nextSibling);
  else left.appendChild(variantLine);

  var priceRow = document.createElement('div');
  priceRow.className = 'sb-price-row';
  left.insertBefore(priceRow, price);
  priceRow.appendChild(price);

  var compare = document.createElement('span');
  compare.className = 'sb-compare';
  compare.hidden = true;
  priceRow.appendChild(compare);

  /* ---------- hulpjes ---------- */
  function textOf(selector) {
    var el = document.querySelector(selector);
    if (!el) return '';
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function currentVariant() {
    if (!product) return null;
    var input = section.querySelector('[data-variant-id-input]') || section.querySelector('[name="id"]');
    var id = input ? Number(input.value) : 0;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id === id) return product.variants[i];
    }
    return product.variants[0];
  }

  function imageFor(variant) {
    var src = '';
    if (variant && variant.featured_image && variant.featured_image.src) src = variant.featured_image.src;
    else if (product && product.featured_image) src = product.featured_image;
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
  }

  /* ---------- bijwerken ---------- */
  var lastSignature = null;

  function render() {
    var variant = currentVariant();
    var oldPrice = textOf('.product-info__compare');
    var variantText = variant ? variant.title.replace(/ \/ /g, ' · ') : '';
    if (variantText === 'Default Title') variantText = '';
    var img = imageFor(variant);

    var signature = JSON.stringify([oldPrice, variantText, img]);
    if (signature === lastSignature) return;
    lastSignature = signature;

    compare.textContent = oldPrice;
    compare.hidden = !oldPrice;

    variantLine.textContent = variantText;
    variantLine.hidden = !variantText;

    if (img) {
      thumb.src = img;
      thumb.hidden = false;
    } else {
      thumb.hidden = true;
    }
  }

  function scheduleRender() {
    if (scheduleRender.queued) return;
    scheduleRender.queued = true;
    setTimeout(function () {
      scheduleRender.queued = false;
      render();
    }, 0);
  }

  /* ============================================================
     Wanneer de balk zichtbaar is
     ============================================================
     Op mobiel scrolt het venster, op grote schermen scrolt .page-wrapper.
     We luisteren op allebei en zetten de balk aan zodra de koopknop
     ruim uit beeld is.

     Later of eerder laten komen? Verander alleen dit getal:
     0 = direct als de knop uit beeld is, 0.6 = ruim een half scherm later. */
  var REVEAL_AFTER_SCREENS = 0.3;

  var addToCartButton = section ? section.querySelector('[data-add-to-cart]') : null;
  var ticking = false;

  function updateVisibility() {
    ticking = false;
    if (!addToCartButton) return;
    var bottom = addToCartButton.getBoundingClientRect().bottom;
    /* 'hidden' met dezelfde regel als het thema (knop uit beeld), zodat
       thema en dit script elkaar niet tegenspreken; de extra vertraging
       loopt via de class sb-gated (display: none in custom.css). */
    var pastButton = bottom <= 0;
    if (bar.hidden === pastButton) bar.hidden = !pastButton;
    bar.classList.toggle('sb-gated', bottom > -(window.innerHeight * REVEAL_AFTER_SCREENS));
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    setTimeout(updateVisibility, 16);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  var pageWrapper = document.querySelector('.page-wrapper');
  if (pageWrapper) pageWrapper.addEventListener('scroll', onScroll, { passive: true });

  updateVisibility();

  /* ---------- in sync blijven met de gekozen variant ---------- */
  var info = section ? section.querySelector('.product-info') : null;
  if (info) {
    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var target = records[i].target;
        var node = target && target.nodeType === 1 ? target : target && target.parentElement;
        if (node && bar.contains(node)) continue;
        scheduleRender();
        return;
      }
    });
    observer.observe(info, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'aria-pressed']
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!event.target.closest || !event.target.closest('[data-option-button]')) return;
      setTimeout(render, 0);
      setTimeout(render, 300);
    },
    true
  );

  render();
})();
